import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/**
 * Normalize a blog from get_cabs_json format (parsed description) to the shape
 * expected by list components (images, created_at, short_description, description).
 */
function normalizeBlogFromCabsJson(parsed) {
  if (!parsed) return null;
  const content = parsed.content || [];
  const firstParagraph = content.find((b) => b.type === "paragraph");
  const excerptText = firstParagraph?.text || "";
  const fullText = content
    .map((b) => (b.text != null ? b.text : ""))
    .filter(Boolean)
    .join(" ");
  return {
    ...parsed,
    images: parsed.cover?.imageUrl ?? parsed.images,
    created_at: parsed.meta?.publishedAt ?? parsed.created_at,
    short_description: parsed.short_description ?? excerptText,
    description: parsed.description ?? fullText,
  };
}

const getBlogCards = createAsyncThunk("blogCards", async (data, { rejectWithValue }) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/website/get_cabs_json`,
      data ?? {},
      config
    );
    const rawData = response?.data?.data;
    if (!Array.isArray(rawData)) {
      return { data: [] };
    }
    const blogList = rawData
      .map((item) => {
        try {
          const parsed = typeof item.description === "string" ? JSON.parse(item.description) : item.description;
          const normalized = normalizeBlogFromCabsJson(parsed);
          if (!normalized) return null;
          return { ...item, ...normalized };
        } catch {
          return null;
        }
      })
      .filter(Boolean);
    return { data: blogList };
  } catch (error) {
    return rejectWithValue(error.response?.data?.message ?? "Failed to fetch blogs");
  }
});

const getBlog = createAsyncThunk("blog", async (data,{rejectWithValue}) => {
    try {
        const config={headers:{'Content-Type':'application/json'}};
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/website/get_blogs`,data,config);
        return response.data;
    }catch(error) {
        return rejectWithValue(error.response.data.message);
    }
});

export {getBlogCards,getBlog}